import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';

import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
import { QuoteDialog } from './components/QuoteDialog';

import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [pathname]);
    return null;
};

function AppShell() {
    const [quoteOpen, setQuoteOpen] = useState(false);
    const open = () => setQuoteOpen(true);

    return (
        <div className="min-h-screen flex flex-col bg-background">
            <Header onOpenQuote={open} />
            <ScrollToTop />
            <div className="flex-1">
                <Routes>
                    <Route path="/" element={<HomePage onOpenQuote={open} />} />
                    <Route path="/services" element={<ServicesPage onOpenQuote={open} />} />
                    <Route path="/about" element={<AboutPage onOpenQuote={open} />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="*" element={<HomePage onOpenQuote={open} />} />
                </Routes>
            </div>
            <Footer />
            <FloatingWhatsApp />
            <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} />
            <Toaster position="bottom-center" richColors closeButton />
        </div>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <AppShell />
        </BrowserRouter>
    );
}
